import {
  AgxGlobalSearch,
  CampaignSearcherResult,
  SearchResultType,
} from '@urbanx/agx.ui-components2';
import { Pages } from 'constants/menu';
import { useNavigate } from 'react-router-dom';

const PageLevelSearch = () => {
  const navigate = useNavigate();

  const onItemSelected = (itemType: SearchResultType, item: CampaignSearcherResult): void => {
    switch (itemType) {
      case SearchResultType.ActiveCampaign:
      case SearchResultType.ArchivedCampaign: {
        const selectedItem = item as CampaignSearcherResult;

        const campaignRoute = `/${Pages.AGENCIES}/${selectedItem.agencyId}/${Pages.CAMPAIGNS}/${selectedItem.campaignId}/${Pages.PROPERTY_INFORMATION}`;

        navigate(campaignRoute);

        break;
      }
      default:
        console.warn(`Unhandled item type selected: ${itemType}`);
    }
  };

  return (
    <AgxGlobalSearch
      searchForCampaigns
      searchForArchivedCampaigns
      onItemSelected={onItemSelected}
    />
  );
};

export default PageLevelSearch;
